angular.module('webpanel').controller('TvUserController', ['$scope', '$routeParams', 'api', 'auth', function($scope, $routeParams, api, auth) {
    $scope.userData = [];
    $scope.operatorData = [];
    $scope.marketingConsent = [];
    $scope.verified = { email: false, cust_phone_number: false };

    $scope.editedField = null;
    $scope.newValue = { bsReference: '' };

    var userKeys = ['name', 'surname', 'email', 'cust_phone_number', 'address', 'id'];
    var operatorKeys = ['operator', 'operator_address', 'operator_phone', 'operator_www'];

    var dictionary = {
        name: 'Imię',
        surname: 'Nazwisko',
        address: 'Adres',
        id: 'Numer ID klienta',
        email: 'E-mail',
        cust_phone_number: 'Telefon',
        operator: 'Nazwa firmy',
        operator_address: 'Adres',
        operator_phone: 'Telefon',
        operator_www: 'Strona WWW',
    };

    var agreementDescriptions = {
        marketing_agreement_1_1: "Wyrażam zgodę na wykorzystywanie przez SGT sp. z o.o. danych o zawartej umowie, zakupach i sposobie korzystania z usług w celu analizowania moich preferencji oraz przygotowywania i przedstawiania mi spersonalizowanych ofert (profilowanie).",
        marketing_agreement_2_1: "Wyrażam zgodę na otrzymywanie od SGT sp. z o.o. informacji handlowych, w tym marketingu bezpośredniego dotyczącego produktów i usług SGT, na podany przeze mnie numer telefonu w formie <strong>połączeń głosowych</strong>, także z wykorzystaniem automatycznych systemów wywołujących.",
        marketing_agreement_2_2: "Wyrażam zgodę na otrzymywanie od SGT sp. z o.o. informacji handlowych, w tym marketingu bezpośredniego dotyczącego produktów i usług SGT, na podany przeze mnie adres <strong>e-mail</strong>.",
        marketing_agreement_2_3: "Wyrażam zgodę na otrzymywanie od SGT sp. z o.o. informacji handlowych, w tym marketingu bezpośredniego dotyczącego produktów i usług SGT, w formie wiadomości <strong>SMS oraz MMS</strong> na podany przeze mnie numer telefonu.",
        marketing_agreement_2_4: "Wyrażam zgodę na otrzymywanie od SGT sp. z o.o. informacji handlowych, w tym marketingu bezpośredniego dotyczącego produktów i usług SGT, w formie <strong>powiadomień push</strong> w aplikacji mobilnej, w serwisie internetowym oraz na dekoderze lub innym urządzeniu odbiorczym."
    };

    // pola kontaktowe, które klient może zmienić i zweryfikować (te same dane co w SMS)
    var contactFields = {
        email: {
            change: api.emailChange,
            verify: api.emailVerifyRequest,
            pattern: /^.+?@.+?\.[a-z]{2,}$/i,
            trackLabel: 'email',
            changedText: 'Adres e-mail został zmieniony. Wysłaliśmy na niego wiadomość z linkiem weryfikacyjnym. ' +
                'Jeśli nie widzisz wiadomości w swojej skrzynce, sprawdź folder SPAM.',
            changeFailedText: 'Nie udało się zmienić adresu e-mail. Upewnij się, że wpisany adres e-mail ma prawidłowy format.',
            verifySentText: 'Wysłaliśmy wiadomość z linkiem weryfikacyjnym. Sprawdź swoją skrzynkę odbiorczą ' +
                '(również folder SPAM).',
            verifyFailedText: 'Nie udało się wysłać wiadomości weryfikacyjnej. Spróbuj ponownie później.',
        },
        cust_phone_number: {
            change: api.phoneChange,
            verify: api.phoneVerifyRequest,
            pattern: /^\d{9,}$/,
            normalize: function(value) { return value.replace(/[\s\-\+\.]/g, ''); },
            trackLabel: 'phone',
            changedText: 'Numer telefonu został zmieniony. Wysłaliśmy na niego SMS z kodem weryfikacyjnym ' +
                'oraz instrukcją, jak potwierdzić numer.',
            changeFailedText: 'Nie udało się zmienić numeru telefonu. Upewnij się, że wpisany numer ma co najmniej 9 cyfr.',
            verifySentText: 'Wysłaliśmy SMS z kodem weryfikacyjnym oraz instrukcją, jak potwierdzić numer.',
            verifyFailedText: 'Nie udało się wysłać SMS-a weryfikacyjnego. Spróbuj ponownie później.',
        },
    };

    var showPopup = function(text, buttonLabel) {
        var pop = $scope.popup.create();
        pop.setText(text);
        pop.addButton(buttonLabel || 'OK', angular.noop, 'yes', true);
        $scope.popup.push(pop);
    };

    $scope.translate = function(label) {
        if (typeof dictionary[label] !== 'undefined') {
            return dictionary[label];
        } else {
            return '((' + label + '))';
        }
    };

    var fetch = function() {
        var newData = $scope.user.get();

        var userData = [];
        var operatorData = [];

        for (var i = 0; i < userKeys.length; i++) {
            if (typeof newData[userKeys[i]] !== 'undefined') {
                userData.push({
                    label: userKeys[i],
                    value: newData[userKeys[i]],
                });
            }
        }

        for (var j = 0; j < operatorKeys.length; j++) {
            if (typeof newData[operatorKeys[j]] !== 'undefined') {
                var row = {
                    label: operatorKeys[j],
                    value: newData[operatorKeys[j]],
                };

                if (row.label === 'operator_www' && row.value) {
                    if (!row.value.match(/^https?:\/\//i)) row.value = 'http://' + row.value;
                    row.link = true;
                }

                operatorData.push(row);
            }
        }

        $scope.userData = userData;
        $scope.operatorData = operatorData;

        $scope.verified = {
            email: newData.cust_email_verified == 1,
            cust_phone_number: newData.cust_phone_verified == 1,
        };
        $scope.marketingConsent = newData.agreements;

        api.marketingAgreementsGet().then(function(response) {
            $scope.marketingConsent = response.data.map(function(consent) {
                consent.desc = agreementDescriptions[consent.agreement] || '(nieznana zgoda)';
                if (consent.agreement === 'marketing_agreement_1_1') {
                    consent.title = 'Zgoda na profilowanie i personalizację';
                } else if (consent.agreement === 'marketing_agreement_2_1') {
                    consent.title = 'Zgody kanałowe (formy kontaktu)';
                }
                return consent;
            });
        }).catch(function(error) {
            console.error('Error fetching marketing agreements:', error);
        });
    };

    var handleMailConfirmation = function(token) {
        var pop = $scope.popup.create();

        $scope.location.path('/twoje-konto/twoje-dane');
        $scope.location.replace();

        api.emailChangeConfirm(token).then(function() {
            pop.setText('Adres e-mail został zmieniony.');
            pop.addButton('OK', angular.noop, 'yes', true);
            $scope.popup.push(pop);

            $scope.user.update();

            $scope.analytics.trackEvent('user', 'email_change_confirm');
        }).catch(function() {
            pop.setText('Nie udało się potwierdzić zmiany adresu e-mail.');
            pop.addButton('Spróbuj ponownie', angular.noop, 'yes', true);
            $scope.popup.push(pop);

            $scope.user.update();
        });
    };

    $scope.isContactField = function(label) {
        return contactFields.hasOwnProperty(label);
    };

    // backend zwraca zamaskowany numer "***-***-" gdy klient nie ma telefonu
    $scope.hasValue = function(row) {
        if (row.label === 'cust_phone_number') return $scope.user.hasPhoneNumber();
        return !!row.value;
    };

    $scope.displayValue = function(row) {
        if (row.label === 'cust_phone_number' && !$scope.hasValue(row)) return '---';
        return row.value || '---';
    };

    $scope.isNewValueValid = function() {
        var field = contactFields[$scope.editedField];
        if (!field) return false;

        var value = $scope.newValue.bsReference.trim();
        if (field.normalize) value = field.normalize(value);

        return field.pattern.test(value);
    };

    $scope.changeContact = function(row) {
        $scope.editedField = row.label;
        // telefon jest maskowany, więc nie da się go wstawić do pola edycji
        $scope.newValue.bsReference = row.label === 'email' ? (row.value || '') : '';
    };

    $scope.changeContactCancel = function() {
        $scope.editedField = null;
        $scope.newValue.bsReference = '';
    };

    $scope.changeContactConfirm = function() {
        if (!$scope.isNewValueValid()) return;

        var field = contactFields[$scope.editedField];
        var value = $scope.newValue.bsReference.trim();

        field.change(value).then(function() {
            $scope.analytics.trackEvent('user', field.trackLabel + '_change');
            $scope.changeContactCancel();

            // zmiana zeruje weryfikację, więc od razu wysyłamy nową
            return field.verify().then(function() {
                showPopup(field.changedText, 'Rozumiem');
            }).catch(function() {
                showPopup('Zmiana została zapisana. ' + field.verifyFailedText);
            });
        }).catch(function() {
            showPopup(field.changeFailedText, 'Spróbuj ponownie');
        }).finally(function() {
            $scope.user.update();
        });
    };

    $scope.verifyContact = function(label) {
        var field = contactFields[label];

        field.verify().then(function() {
            $scope.analytics.trackEvent('user', field.trackLabel + '_verify');
            showPopup(field.verifySentText);
        }).catch(function() {
            showPopup(field.verifyFailedText);
        });
    };

    $scope.securityGlobalLogout = function() {
        var pop = $scope.popup.create();

        pop.setText('Czy na pewno chcesz wylogować się ze wszystkich urządzeń? Spowoduje to ' +
            'zresetowanie preferencji automatycznego logowania oraz zakończenie trwających sesji Chromecast.');

        pop.addButton('Wyloguj ze wszystkich urządzeń', function() {
            api.userPairMassDestroy().then(function() {
                auth.destroy();
                location.reload();
            }).catch(function() {
                console.log('epic fail');
            });
        }, 'yes', true);

        pop.addButton('Anuluj', angular.noop, 'no');
        $scope.popup.push(pop);
    };

    $scope.changeConsent = function(consent) {
        consent.value = (consent.value === 'enabled') ? 'disabled' : 'enabled';

        var formattedData = {};
        $scope.marketingConsent.forEach(function(consent) {
            formattedData[consent.agreement] = consent.value;
        });

        api.marketingAgreementsSet(formattedData).catch(function(error) {
            console.error('Error updating marketing consents:', error);
        });
    };

   
    $scope.user.addObserver('tvUserUserObserver', function(type) {
        switch (type) {
            case 'change':
                fetch();
                break;
        }
    });

    $scope.$on('$destroy', function() {
        $scope.user.removeObserver('tvUserUserObserver');
    });

    if ($scope.user.isDemo()) {
        $scope.showLoginPrompt(true);
    } else {
        fetch();

        if (typeof $routeParams.emailToken !== 'undefined') {
            handleMailConfirmation($routeParams.emailToken);
        }
    }

}]);
